import React from 'react';
import { DocPageLayout } from '../components/DocPageLayout';
import { InfoBox } from '../components/InfoBox';
import { CodeBlock } from '../components/CodeBlock';
export function ShoppingCartPage() {
  const plugins = [{
    name: 'WooCommerce',
    version: '2.4.1',
    platform: 'WordPress',
    color: 'bg-purple-100 text-purple-700',
    desc: 'Full-featured plugin for WooCommerce stores with support for all payment methods, refunds, and tokenization.'
  }, {
    name: 'Magento 2',
    version: '3.1.0',
    platform: 'Adobe Commerce',
    color: 'bg-orange-100 text-orange-700',
    desc: 'Enterprise-grade extension for Magento 2 with multi-store support, vault integration, and admin payment management.'
  }, {
    name: 'PrestaShop',
    version: '1.8.2',
    platform: 'PrestaShop',
    color: 'bg-blue-100 text-blue-700',
    desc: 'Easy-to-install module for PrestaShop with Checkout and Hosted Session integration options.'
  }, {
    name: 'OpenCart',
    version: '1.5.0',
    platform: 'OpenCart',
    color: 'bg-green-100 text-green-700',
    desc: 'Lightweight extension for OpenCart supporting Checkout integration with automatic order status updates.'
  }];
  return <DocPageLayout title="Shopping Cart Plugin" description="Pre-built plugins for popular e-commerce platforms that require minimal development effort." data-id="element-2038">
      <p className="text-gray-700 mb-6" data-id="element-2039">
        Our shopping cart plugins provide ready-made integrations for popular
        e-commerce platforms. Simply install the plugin, configure your merchant
        credentials, and start accepting payments — no custom development
        required.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-2040">
        Supported Platforms
      </h2>
      <div className="space-y-4 mb-8" data-id="element-2041">
        {plugins.map(plugin => <div key={plugin.name} className="border border-gray-200 rounded-lg p-6 hover:shadow-sm transition-shadow" data-id="element-2042">
            <div className="flex items-start justify-between mb-3" data-id="element-2043">
              <div data-id="element-2044">
                <h3 className="text-lg font-bold text-gray-900" data-id="element-2045">
                  {plugin.name}
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2046">{plugin.platform}</p>
              </div>
              <span className={`text-xs font-semibold px-3 py-1 rounded-full ${plugin.color}`} data-id="element-2047">
                v{plugin.version}
              </span>
            </div>
            <p className="text-sm text-gray-600 mb-4" data-id="element-2048">{plugin.desc}</p>
            <a href="#" className="text-sm font-medium text-[#CC5500] hover:underline" data-id="element-2049">
              Download Plugin →
            </a>
          </div>)}
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-2050">
        Installation (WooCommerce Example)
      </h2>
      <CodeBlock language="Bash" title="WooCommerce Installation" code={`# Option 1: Install via WordPress Admin
# Navigate to: Plugins > Add New > Upload Plugin
# Upload the downloaded .zip file

# Option 2: Install via WP-CLI
wp plugin install gateway-payment-plugin.zip --activate

# Option 3: Manual Installation
cd wp-content/plugins/
unzip gateway-payment-plugin.zip
wp plugin activate gateway-payment-plugin`} data-id="element-2051" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-2052">
        Configuration
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-2053">
        After installation, navigate to your platform's payment settings and
        enter the following credentials:
      </p>
      <div className="overflow-x-auto my-6" data-id="element-2054">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-2055">
          <thead data-id="element-2056">
            <tr className="bg-gray-50" data-id="element-2057">
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-2058">
                Setting
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-2059">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100" data-id="element-2060">
            <tr data-id="element-2061">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-2062">Merchant ID</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-2063">
                Your gateway merchant identifier
              </td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-2064">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-2065">API Password</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-2066">
                Your API authentication password
              </td>
            </tr>
            <tr data-id="element-2067">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-2068">Gateway URL</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-2069">
                The gateway endpoint (test or production)
              </td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-2070">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-2071">Integration Type</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-2072">
                Choose Checkout or Hosted Session
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <InfoBox type="warning" title="Plugin Versioning" data-id="element-2073">
        Always use the latest version of the plugin compatible with your
        platform version. Older plugin versions may not support the latest API
        features or security updates.
      </InfoBox>
    </DocPageLayout>;
}